import React, { useEffect } from "react";
import { Form, InputNumber, Typography } from "antd";
import { elvis } from "../../Utils";

const { Title } = Typography;

const ProductDamageForm = props => {
  const [form] = Form.useForm();
  const isEditMode = props.isEditMode || false;

  const formItemLayout = {
    labelCol: { sm: { span: 8 } },
    wrapperCol: { sm: { span: 16 } }
  };

  useEffect(() => {
    if (props.record.damage) {
      form.setFieldsValue({
        qualityLossPercentage: props.record.damage.qualityLossPercentage,
        manufacturingLossPercentage: props.record.damage.manufacturingLossPercentage,
        totalDamagePercentage: props.record.damage.totalDamagePercentage,
        nonProducedGoodQuantity: props.record.damage.nonProducedGoodQuantity,
        nonTransformedGoodQuantity: props.record.damage.nonTransformedGoodQuantity
      });
    }
  }, [props.record.damage, form]);

  const onValuesChange = (changedValues) => {
    form.validateFields(Object.keys(changedValues));
  };

  const onFieldsChange = () => {
    if (!isEditMode) return;
    const fieldsError = form.getFieldsError();
    const valid = fieldsError.every(field => !field.errors || field.errors.length === 0);
    const values = form.getFieldsValue();
    const newDamage = { ...props.record };
    newDamage.damage.qualityLossPercentage = elvis(values.qualityLossPercentage);
    newDamage.damage.manufacturingLossPercentage = elvis(values.manufacturingLossPercentage);
    newDamage.damage.totalDamagePercentage = elvis(values.totalDamagePercentage);
    newDamage.damage.nonProducedGoodQuantity = elvis(values.nonProducedGoodQuantity);
    newDamage.damage.nonTransformedGoodQuantity = elvis(values.nonTransformedGoodQuantity);
    newDamage.valid = valid;
    props.parentCallback(newDamage);
  };

  return (
    <Form
      {...formItemLayout}
      className="details_form"
      form={form}
      onValuesChange={onValuesChange}
      onFieldsChange={onFieldsChange}
      name="productDamage"
    >
      <Title className="details_form_header" title="Damages details" subTitle="Product" />
      <Form.Item label="Quality loss (%)" name="qualityLossPercentage">
        <InputNumber disabled={!isEditMode} min={0} max={100} />
      </Form.Item>
      <Form.Item label="Manufacturing loss (%)" name="manufacturingLossPercentage">
        <InputNumber disabled={!isEditMode} min={0} max={100} />
      </Form.Item>
      <Form.Item label="Total damage (%)" name="totalDamagePercentage">
        <InputNumber disabled={!isEditMode} min={0} max={100} />
      </Form.Item>
      <Form.Item label="Quantity of non-produced goods" name="nonProducedGoodQuantity">
        <InputNumber disabled={!isEditMode} min={0} />
      </Form.Item>
      <Form.Item label="Quantity of non-transformed goods" name="nonTransformedGoodQuantity">
        <InputNumber disabled={!isEditMode} min={0} />
      </Form.Item>
    </Form>
  );
};

export default ProductDamageForm;
